import { NavLink } from 'react-router-dom';
import { useProjectNavItems } from './projectNavItems';

export default function PageTabs({ projectId }: { projectId: string }) {
    const items = useProjectNavItems(projectId);

    return (
        <div className="flex flex-wrap gap-1">
            {items.map((item) => (
                <NavLink
                    key={item.key}
                    to={item.disabled ? '#' : item.to}
                    end={item.end}
                    onClick={(e) => {
                        if (item.disabled) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                    className={({ isActive }) => {
                        const base =
                            'px-3 py-1.5 text-sm rounded-lg inline-flex items-center transition-colors duration-150';
                        if (item.disabled) return `${base} bg-gray-100 text-gray-400 cursor-not-allowed`;
                        return `${base} ${isActive ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-100'}`;
                    }}
                    aria-disabled={item.disabled}
                >
                    {item.label}
                </NavLink>
            ))}
        </div>
    );
}
